import { render, staticRenderFns } from "./GoalPicker.vue?vue&type=template&id=e4d6080e"
import script from "./GoalPicker.vue?vue&type=script&lang=js"
export * from "./GoalPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports